export default "assets/images/ed4f5f77ee33faef9a419b08b4a29400.png";